import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RewardsState } from './rewards.state';

export const selectRewardsState = createFeatureSelector<RewardsState>('adminRewards');

export const selectAllRewards = createSelector(
  selectRewardsState,
  (state) => state.rewards,
);

export const selectRewardsLoading = createSelector(
  selectRewardsState,
  (state) => state.loading,
);

export const selectRewardsError = createSelector(
  selectRewardsState,
  (state) => state.error,
);

export const selectRewardsPagination = createSelector(
  selectRewardsState,
  (state) => state.pagination,
);
